import { z } from 'zod';

import { translate } from '@wecasa/i18n';

import { EMAIL_REGEX } from './email';

const t = translate('inputs');

export const emailRegexp: Record<string, RegExp> = {
  // Only the domain has a 2-char minimum
  tooShort: /^[^@]+@[^@]\.[a-z]{2,}$/i,
  default: EMAIL_REGEX,
};

export const emailSchema = z.string().superRefine((value, ctx) => {
  if (value.length === 0) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: t('.email.errors.required'),
    });
  } else if (emailRegexp.tooShort.test(value)) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: t('.email.errors.too_short'),
    });
  } else if (!emailRegexp.default.test(value)) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: t('.email.errors.invalid'),
    });
  }
});
